import { FC, useEffect, useMemo, useState } from "react";
import useProfile from "../../../hooks/use-profile";
import { Loading, Markdown, unifyLanguageName } from "@quark/design";
import styles from "./index.module.scss";
import AnswerBlurImage from "./answer-blur.png";
import { useNavigate } from "react-router-dom";
import { getChallengeAnswer } from "../../../api";
import { ChallengeAnswer } from "../../../types/Challenge";

interface CoachAnswerProps {
  challengeId: number;
}

const CoachAnswer: FC<CoachAnswerProps> = ({
  challengeId,
}) => {
  const navigate = useNavigate();
  const profile = useProfile();
  const isVip = useMemo(() => {
    return !!profile?.vip_infos.length;
  }, [profile]);
  const [loading, setLoading] = useState(false);
  const [answers, setAnswers] = useState<ChallengeAnswer[]>([]);

  const toVipPage = () => {
    navigate("/vip");
  };

  unifyLanguageName("python");

  useEffect(() => {
    if (isVip) {
      setLoading(true);
      getChallengeAnswer(challengeId)
        .then((res) => {
          setAnswers(res);
        }).finally(() => {
          setLoading(false);
        })
    }
  }, [isVip]);

  if (loading) return <Loading />

  if (!isVip) return (
    <div className={styles.vipPurchase}>
      <img src={AnswerBlurImage} alt="" />
      <div className={styles.text}>
        <div>【开学季特惠】买1年送1年，畅学22+精品课程</div>
        <div>1 v 1 答疑，免费查看全部题库官方解答</div>
        <div className={styles.vipBtn} onClick={toVipPage}>仅会员可见, 去开通会员</div>
      </div>
    </div>
  )

  return (
    <div className={styles.answers}>
      {answers.map((answer) => (
        <div className={styles.answer} key={answer.id}>
          <Markdown>
            {`\`\`\`${unifyLanguageName(answer.language)}\n${answer.solution_code}\n\`\`\``}
          </Markdown>
        </div>
      ))}
    </div>
  )
}

export default CoachAnswer;
